import React from 'react';
import * as Popover from '@radix-ui/react-popover';
import { Crown } from 'lucide-react';
import Tooltip from '../../../ui/Tooltip';
import './CommanderTaxMenu.css';

/**
 * Commander-Steuer-Menü (Spec 2026-10-21 §14): die Krone der Commander-Zone mit dem Wert „+n"
 * als Popover-Auslöser; das Menü erhöht, verringert oder setzt den Wert zurück.
 *
 *   <CommanderTaxMenu value={tax} onChange={(change) => …} disabled={!canAct} />
 *
 * - `onChange(1)` / `onChange(-1)` für „+1" / „−1", `onChange({ reset: true })` für
 *   „Zurücksetzen". Ein fehlender `value` gilt als 0; „−1" und „Zurücksetzen" sind bei 0 gesperrt.
 * - `disabled` sperrt den Auslöser. Der Auslöser trägt den Tooltip „Commander-Steuer".
 * - Klick, Taste und Zeiger-Druck im Auslöser und im Menü erreichen die umgebende Kachel nicht
 *   (React-Ereignisse laufen auch durch das Portal nach oben): kein Kachel-Klick, kein Zug.
 */
const stop = (e) => e.stopPropagation();

export default function CommanderTaxMenu({ value, onChange, disabled = false }) {
  const [open, setOpen] = React.useState(false);
  const tax = value || 0;
  const keepInside = { onClick: stop, onKeyDown: stop, onPointerDown: stop };
  return (
    <Popover.Root open={open && !disabled} onOpenChange={setOpen}>
      <Popover.Trigger asChild>
        <Tooltip label="Commander-Steuer">
          <button
            type="button"
            className="commander-tax__trigger"
            disabled={disabled}
            {...keepInside}
          >
            <Crown size={14} aria-hidden />
            <span className="commander-tax__value" data-testid="commander-tax-value">+{tax}</span>
          </button>
        </Tooltip>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content className="commander-tax__menu" {...keepInside} side="top" align="start" sideOffset={6} collisionPadding={8}>
          <button type="button" className="commander-tax__item" onClick={() => onChange(1)}>+1</button>
          <button type="button" className="commander-tax__item" disabled={tax === 0} onClick={() => onChange(-1)}>−1</button>
          <button type="button" className="commander-tax__item" disabled={tax === 0} onClick={() => onChange({ reset: true })}>Zurücksetzen</button>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
